export default {
  MEDIA_QUERY_LABEL: '@media only screen and'
};